module.exports = __webpack_public_path__ + "img/turbo_on.c8bf09ba.png";